import store from "../vuex";
// const store_allPermissions = store.getters.getAuthorityBtnsByAllPage;
const getPermissionByPageFunc = store.getters.getAuthorityBtnsByPage;
//动态权限按钮
/*
v-permission.sys:menu:add="sys/menu"
- 字符串sys:menu:add从按钮权限表格中对应
- sys/menu对应到vuex的权限数组
- 如果没有匹配到，就不显示按钮

*/
function renderPermission(el, bindings) {
    // console.log("自定义指令bindings", bindings);
    let { rawName, expression, modifiers } = bindings;
    expression = expression.replaceAll('\'', "", 'mgi');
    const permission = getPermissionByPageFunc('auth__' + expression) || [];//vuex obj path key
    // console.log("permission", permission);
    const authStr = ('' + rawName).replace("v-permission.", "");
    const idx = permission.indexOf(authStr);
    // console.log("校验", permission, authStr);
    if (idx == -1) {
        el.parentNode.removeChild(el);
        // el.remove();
        // el.style.display = 'none';
        // console.log("删除当前节点", el.parentNode);
    }
}
export default {
    bind(el, bindings) {
        // console.log("仓库的所有权限：", store_allPermissions, getPermissionByPageFunc('/sys/menu'));
        // renderPermission(el, bindings);
        // renderPermission(el, bindings);

    },
    inserted(el, bindings) {
        // console.log('inserted', el, bindings);
        renderPermission(el, bindings);
    },
    mounted(el, bindings) {
        // renderPermission(el, bindings);

    },
    update(el, bindings) {
        // console.log('update');


    },
    // componentUpdated(el, bindings) {
    //     console.log('componentUpdated');

    // },
    // unbind(el, bindings) {
    //     console.log('unbind');
    // },
}


// WEBPACK FOOTER //
// ./src/directives/permission.js